// extracted by mini-css-extract-plugin
export var cardIcon = "_59-4";
export var checkboxCard = "_59-0";
export var checkboxCardSelected = "_59-3";
export var disabled = "_59-1";
export var outerBorder = "_59-2";
export var spacerMedium = "_59-7";
export var spacerSmall = "_59-6";
export var spacerXsmall = "_59-5";